import { Button, makeStyles, Typography } from '@material-ui/core';
import ButtonSpinner from 'components/ButtonSpinner';
import FormDialog from 'components/Dialogs/FormDialog';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useFirestore } from 'react-redux-firebase';
import { enqueueErrorSnackbar } from 'redux/actions/notifierActions';
import { sleep } from 'utils/sleep';
import CsvDownloader from 'react-csv-downloader';

const useStyles = makeStyles(theme => ({
  cancelButton: {
    width: 105,
    height: 40,
    marginRight: 'auto',
    background: '#9E9E9E',
    color: '#fff',
    fontSize: 14,
    '&:hover': {
      background: '#9E9E9E',
      opacity: 0.9,
    },
  },
  agreeButton: {
    width: 200,
    height: 40,
    background: theme.palette.primary.main,
    color: '#fff',
    fontSize: 14,
    '&:hover': {
      background: theme.palette.primary.main,
      opacity: 0.9,
    },
    '&:disabled': {
      background: '#9E9E9E',
      color: '#fff',
    },
  },
}));

const VcEventAttendeeCsvDownloadDialog = ({
  isCsvDialogOpen,
  toggleCsvDialog,
  eventId,
  eventName,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const db = useFirestore();
  const [isFetching, setIsFetching] = useState(false);

  const getCsvData = async () => {
    setIsFetching(true);
    try {
      const doc = await db.collection('vcEventAttendees').doc(eventId).get();

      if (doc.exists) {
        await sleep(1000);

        setTimeout(() => {
          toggleCsvDialog();
        }, 250);

        return doc.data().attendees;
      } else {
        dispatch(enqueueErrorSnackbar('No RSVPs found'));
      }
    } catch (error) {
      console.error(error);
      dispatch(enqueueErrorSnackbar('Error creating CSV'));
    } finally {
      setIsFetching(false);
    }
  };

  const handleCsvDownload = () => {
    document.getElementById(`${eventId}-csv-download`).click();
  };

  return (
    <FormDialog
      isOpen={isCsvDialogOpen}
      handleClose={toggleCsvDialog}
      title="Acceptable‑Use Notice"
      content={<div>Hello</div>}
    >
      <div className="mb-3">
        <Typography>
          By clicking <span className="fw-500">“Agree & Download”</span> you confirm that you will:
        </Typography>
        <Typography>
          <ol>
            <li className="mb-2">
              <Typography className="fw-500 mb-1">
                Use the e‑mail addresses only to communicate about this specific event.
              </Typography>
              <ul>
                <li>
                  <Typography>
                    This is a notice of the Acceptable‑Use Policy for the event.
                  </Typography>
                </li>
              </ul>
            </li>
            <li className="mb-2">
              <Typography className="fw-500 mb-1">
                Comply with all applicable laws and policies.
              </Typography>
              <ul>
                <li>
                  <Typography>U.S. CAN‑SPAM Act</Typography>
                </li>
                <li>
                  <Typography>EU data‑protection regulations (e.g., GDPR)</Typography>
                </li>
                <li>
                  <Typography>Voltage Control Privacy Policy</Typography>
                </li>
              </ul>
            </li>
            <li className="mb-2">
              <Typography className="fw-500 mb-1">Protect the data.</Typography>
              <ul>
                <li>
                  <Typography>
                    Store it securely, share only with authorized team members, and delete it when
                    no longer required for event follow‑up.
                  </Typography>
                </li>
              </ul>
            </li>
          </ol>
        </Typography>
        <Typography>
          Sending any other type of e‑mail—even a “related” newsletter—requires fresh, documented
          consent from each recipient.
        </Typography>
      </div>
      <div className="d-flex justify-content-between mb-3">
        <Button className={classes.cancelButton} disabled={isFetching} onClick={toggleCsvDialog}>
          CANCEL
        </Button>
        <Button className={classes.agreeButton} onClick={handleCsvDownload} disabled={isFetching}>
          Agree & Download
          {isFetching && <ButtonSpinner />}
        </Button>
      </div>
      <div style={{ display: 'none' }}>
        <CsvDownloader
          id={`${eventId}-csv-download`}
          columns={[
            {
              id: 'name',
              displayName: 'Name',
            },
            {
              id: 'email',
              displayName: 'Email',
            },
            {
              id: 'date_created',
              displayName: 'RSVP Date',
            },
          ]}
          datas={getCsvData}
          filename={`${eventName}-RSVPs`}
        ></CsvDownloader>
      </div>
    </FormDialog>
  );
};

export default VcEventAttendeeCsvDownloadDialog;
